/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AuthUserResponse as ModelsAuthUserResponse } from '../../models/models/auth-user-response';

export interface ApiV1AuthMeGet$Params {
}

export function apiV1AuthMeGet(http: HttpClient, rootUrl: string, params?: ApiV1AuthMeGet$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsAuthUserResponse>> {
  const rb = new RequestBuilder(rootUrl, apiV1AuthMeGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsAuthUserResponse>;
    })
  );
}

apiV1AuthMeGet.PATH = '/api/v1/auth/me';
